import { useState } from 'react';
import {
  ConnectComponentsProvider,
  ConnectNotificationBanner,
  ConnectPayoutsList,
} from '@stripe/react-connect-js';
import { Box, Stack } from '@mui/material';
import { NotificationCount } from '@stripe/connect-js';
import useStripeAccountSession from '../../hooks/stripe/useStripeAccountSession';
import useStripeAccountSocket from '../../hooks/stripe/useStripeAccountSocket';
import StripeAccountBalance from './StripeAccountBalance';
import { StripeSummary } from '../../types/stripe';

interface Props {
  summary: StripeSummary;
}

function StripeBankPayouts({ summary }: Props) {
  const [notificationsVisible, setNotificationsVisible] = useState(false);

  const connectInstance = useStripeAccountSession();
  useStripeAccountSocket();

  const onNotificationsChange = ({
    total,
    actionRequired,
  }: NotificationCount) => {
    setNotificationsVisible(total > 0 || actionRequired > 0);
  };

  if (!connectInstance) return null;

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <Stack gap={2}>
        <Box display={notificationsVisible ? 'block' : 'none'}>
          <ConnectNotificationBanner
            onNotificationsChange={onNotificationsChange}
          />
        </Box>

        <StripeAccountBalance summary={summary} />

        <ConnectPayoutsList />
      </Stack>
    </ConnectComponentsProvider>
  );
}

export default StripeBankPayouts;
